<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<template v-slot:header>
							<i class="icon-pencil"></i> Create Purchase Order
						</template>
						<b-card-body>
							<b-form @submit.prevent="checkFormValidity()" method="post">
								<b-form-group
									label="Select Project"
									label-for="projectName"
									label-class="required"
									:label-cols="3"
									:horizontal="true"
									invalid-feedback="Please select one."
									:state="$v.form.projectId.$dirty ? !$v.form.projectId.$error : null">
									<model-select id="projectName" :options="projectNameDropDownList" v-model="form.projectId" :isError="$v.form.projectId.$dirty ? $v.form.projectId.$error : false" placeholder="Select Project Name"></model-select>
								</b-form-group>
								<b-form-group
									label="Date of Purchase" label-for="purchaseDate"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.purchaseDate" name="purchaseDate" type="date" id="purchaseDate" :state="$v.form.purchaseDate.$dirty ? !$v.form.purchaseDate.$error : null" aria-describedby="purchase-date-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="purchase-date-live-feedback">This is a required field.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Number of Devices"
									label-for="deviceQuantity"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.deviceQuantity" name="deviceQuantity" id="deviceQuantity" type="number" placeholder="Quantity" :state="$v.form.deviceQuantity.$dirty ? !$v.form.deviceQuantity.$error : null" aria-describedby="device-quantity-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="device-quantity-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Device Unit Price"
									label-for="deviceUnitPrice"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.deviceUnitPrice" name="deviceUnitPrice" id="deviceUnitPrice" type="number" placeholder="Device Price" :state="$v.form.deviceUnitPrice.$dirty ? !$v.form.deviceUnitPrice.$error : null" aria-describedby="unit-price-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="unit-price-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Select Software Version"
									label-for="version-id"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-select v-model="form.versionId"
																 name="versionId"
																 id="version-id"
																 :plain="true"
																 :options="versionNameDropDownList"
																 value="Please Select"
																 :state="$v.form.versionId.$dirty ? !$v.form.versionId.$error : null"
																 aria-describedby="version-live-feedback">
									</b-form-select>
									<b-form-invalid-feedback id="version-live-feedback">Please select one.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Software Package Fee"
									label-for="software-package-fee"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.softwarePackageFee" name="softwarePackageFee" id="software-package-fee" type="number" placeholder="Package Price" :state="$v.form.softwarePackageFee.$dirty ? !$v.form.softwarePackageFee.$error : null" aria-describedby="software-package-fee-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="software-package-fee-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
								</b-form-group>
								<b-row>
									<b-col>
										<b-card title="Client Information">
											<b-card-body>
												<b-form-group
													label="Name"
													label-for="client-name"
													label-class="required"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientName"
														name="clientName"
														id="client-name"
														type="text"
														placeholder="Client Name"
														:state="$v.form.clientName.$dirty ? !$v.form.clientName.$error : null"
														aria-describedby="client-name-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-name-live-feedback">This is a required field and must not be empty.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Email"
													label-for="client-email"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientEmail"
														name="clientEmail"
														id="client-email"
														type="text"
														placeholder="Client Email"
														:state="$v.form.clientEmail.$dirty ? !$v.form.clientEmail.$error : null"
														aria-describedby="client-email-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-email-live-feedback">Invalid Email Address.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Phone"
													label-for="client-phone"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientPhone"
														name="clientPhone"
														id="client-phone"
														type="text"
														placeholder="Client Phone No."
														:state="$v.form.clientPhone.$dirty ? !$v.form.clientPhone.$error : null"
														aria-describedby="client-phone-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-phone-live-feedback">Invalid Phone Number.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Company"
													label-for="client-company"
													label-class="required"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientCompany"
														name="clientCompany"
														id="client-company"
														type="text"
														placeholder="Client Company Name"
														:state="$v.form.clientCompany.$dirty ? !$v.form.clientCompany.$error : null"
														aria-describedby="client-company-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-company-live-feedback">This is a required field and must not be empty.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Address"
													label-for="client-address"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientAddress"
														name="clientAddress"
														id="client-address"
														type="text"
														placeholder="Client Address"
														:state="$v.form.clientAddress.$dirty ? !$v.form.clientAddress.$error : null"
														aria-describedby="client-address-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-address-live-feedback">Invalid Address.</b-form-invalid-feedback>
												</b-form-group>
											</b-card-body>
										</b-card>
									</b-col>
								</b-row>
								<div class="form-actions">
									<b-button type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Create P.O.</b-button>
									&nbsp;
									<b-button type="reset" variant="danger" @click="resetForm()"><i class="fa fa-ban"></i> Reset</b-button>
								</div>
							</b-form>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import { required, numeric, minValue, requiredIf, email, maxValue } from "vuelidate/lib/validators";
import toastService from "@/services/toastService";
import customerService from "@/services/customerService";
import purchaseOrderService from "@/services/purchaseOrderService";
import {ModelSelect} from "vue-search-select";
import versionService from '@/services/versionService'

export default {
	name : "CreatePurchaseOrder",
	components : {
		ModelSelect
	},
	data : function () {
		return {
			form : {
				projectId : null,
				purchaseDate : null,
				deviceQuantity : null,
				deviceUnitPrice : null,
				versionId : null,
				softwarePackageFee : null,
				clientName : null,
				clientEmail : null,
				clientCompany : null,
				clientPhone : null,
				clientAddress : null
			},
			projectNames : [],
			projectNameDropDownList : [],
			versions : [],
			versionNameDropDownList : [
				{text: "Please Select", value: null}
			],
			loading: false
		}
	},
	validations : {
		form : {
			projectId : {
				required,
				minValue: minValue(1)
			},
			purchaseDate : {
				required
			},
			deviceQuantity : {
				required,
				minValue: minValue(1)
			},
			deviceUnitPrice : {
				required,
				minValue: minValue(1)
			},
			versionId : {
				required,
				minValue : minValue(1),
				maxValue : maxValue(10)
			},
			softwarePackageFee : {
				required
			},
			clientName : {
				required
			},
			clientEmail : {
				validEmail : email
			},
			clientCompany : {
				required
			},
			clientPhone : {

			},
			clientAddress : {

			}
		}
	},
	methods : {
		checkFormValidity : function(){
			let formHasErrors = false;

			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.createPurchaseOrder();
		},
		createPurchaseOrder : function () {
			let selectedProject = this.projectNameDropDownList.find((item) => item.value === this.form.projectId);
			const formData = {
				projectId: this.form.projectId,
				projectName: selectedProject.text.trim(),
				purchaseDate: new moment(this.form.purchaseDate,'YYYY-MM-DD').format('x'),
				deviceQuantity: this.form.deviceQuantity,
				deviceUnitPrice: this.form.deviceUnitPrice,
				softwarePackageFee: this.form.softwarePackageFee,
				versionId: this.form. versionId,
				clientName: this.form.clientName ? this.form.clientName.trim() : null,
				clientEmail: this.form.clientEmail ? this.form.clientEmail.trim() : null,
				clientPhone: this.form.clientPhone ? this.form.clientPhone.trim() : null,
				clientCompanyName: this.form.clientCompany ? this.form.clientCompany.trim() : null,
				clientAddress: this.form.clientAddress ? this.form.clientAddress.trim() : null
			}

			purchaseOrderService.createPurchaseOrder(formData, (data) => {
				// this.$nextTick(() => { this.$v.$reset() });
				this.resetForm();
				toastService.showSuccessToast("Purchase order created successfully");
			}, (error) => {
				this.$nextTick(() => { this.$v.$reset() });
				toastService.showErrorToast("Could not create purchase order " + error);
			});
		},
		resetForm: function () {
			this.form.projectId = null;
			this.form.purchaseDate = null;
			this.form.deviceQuantity = null;
			this.form.deviceUnitPrice = null;
			this.form.softwarePackageFee = null;
			this.form.versionId = null;
			this.form.clientName = null;
			this.form.clientEmail = null;
			this.form.clientPhone = null;
			this.form.clientAddress = null;
			this.form.clientCompany = null;
			this.$nextTick(() => { this.$v.$reset() });
		},
		getProjectNames : function () {
			this.loading = true;
			customerService.getProjectNames((data) => {
				this.projectNames = data;
				this.createProjectNameDropDownList();
				this.loading = false;
			}, (error) => {
				this.loading = false
				toastService.showErrorToast("Could not fetch project names" + error);
			});
		},
		createProjectNameDropDownList : function () {
			this.projectNames.forEach((value) => {
				let project = new Object();
				project.text = value.name;
				project.value = value.id;
				this.projectNameDropDownList.push(project);
			});
		},
		getVersionNameList() {
			versionService.getVersionNameList((data) => {
				this.versions = data;
				this.createVersionNameDropDownList();
			}, (error) => {
				toastService.showErrorToast("Could not fetch version list" + error);
			});
		},
		createVersionNameDropDownList : function () {
			this.versions.forEach((value => {
				let version = new Object();
				version.text = value.name;
				version.value = value.id;
				this.versionNameDropDownList.push(version);
			}));
		}
	},
	created() {
		this.getProjectNames();
		this.getVersionNameList();
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
